









import { defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import ListItem from "@/components/ListItem";
import TransactionMoneyDate from "../TransactionMoneyDate";

export default defineComponent({
  name: "TransactionView",
  components: { TransactionMoneyDate, ListItem },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
});
